import React from "react";
import { Box } from "@mui/material";
import PageTitle from "../base/PageTitle";
import Account from "../views/Account";

interface Props {}

const AccountPage: React.FC<Props> = (props) => {
  return (
    <Box>
      <PageTitle title="Account" />
      <Account />
    </Box>
  );
};

export default AccountPage;
